import React from "react"

const ParentStatsBar = ({ stats, activeFilter, onFilterClick }) => {
  const items = [
    {
      label: "Overdue",
      filterKey: "overdue",
      value: stats?.total_overdue || 0,
      baseColor: "from-red-500 to-rose-600",
      bgColor: "bg-red-50",
      textColor: "text-red-700",
      activeRing: "ring-red-400",
      iconColor: "text-red-500",
      urgent: true,
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      ),
    },
    {
      label: "Today",
      filterKey: "today",
      value: stats?.total_due_today || 0,
      baseColor: "from-amber-500 to-orange-500",
      bgColor: "bg-amber-50",
      textColor: "text-amber-700",
      activeRing: "ring-amber-400",
      iconColor: "text-amber-500",
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      label: "This Week",
      filterKey: "this_week",
      value: stats?.total_due_this_week || 0,
      baseColor: "from-blue-500 to-indigo-500",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
      activeRing: "ring-blue-400",
      iconColor: "text-blue-500",
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      label: "Graded",
      filterKey: "graded",
      value: stats?.total_recently_graded || 0,
      baseColor: "from-violet-500 to-purple-600",
      bgColor: "bg-violet-50",
      textColor: "text-violet-700",
      activeRing: "ring-violet-400",
      iconColor: "text-violet-500",
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
  ]

  const handleClick = (filterKey) => {
    if (onFilterClick) {
      onFilterClick(activeFilter === filterKey ? null : filterKey)
    }
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {items.map((item, index) => {
        const isActive = activeFilter === item.filterKey
        const hasValue = item.value > 0

        return (
          <button
            key={item.label}
            onClick={() => handleClick(item.filterKey)}
            className={`
              stat-card relative p-4 text-left cursor-pointer transition-all duration-200
              hover-lift group
              ${isActive ? `ring-2 ${item.activeRing} shadow-lg` : "shadow-sm hover:shadow-md"}
              stagger-in
            `}
            style={{
              '--accent-color': isActive ? item.baseColor.split(' ')[0].replace('from-', '') : undefined,
              animationDelay: `${index * 50}ms`
            }}
          >
            {/* Gradient accent bar at top */}
            <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${item.baseColor} rounded-t-2xl transition-opacity ${
              hasValue || isActive ? "opacity-100" : "opacity-30"
            }`} />

            {/* Content */}
            <div className="pt-1">
              {/* Icon and Value Row */}
              <div className="flex items-center justify-between mb-1">
                <span className={`${item.iconColor} transition-colors ${!hasValue && !isActive ? "opacity-40" : ""}`}>
                  {item.icon}
                </span>
                <span className={`
                  font-display text-3xl font-bold tracking-tight
                  ${hasValue ? item.textColor : "text-[var(--ink-light)]"}
                  ${item.urgent && hasValue ? "pulse-urgent" : ""}
                `}>
                  {item.value}
                </span>
              </div>

              {/* Label */}
              <p className={`text-sm font-medium ${
                hasValue || isActive ? "text-[var(--ink-muted)]" : "text-[var(--ink-light)]"
              }`}>
                {item.label}
              </p>
            </div>

            {/* Active indicator dot */}
            {isActive && (
              <div className={`absolute bottom-3 right-3 w-2 h-2 rounded-full bg-gradient-to-r ${item.baseColor}`} />
            )}
          </button>
        )
      })}
    </div>
  )
}

export default ParentStatsBar
